import React, { Component } from 'react';
import queryString from 'query-string';
import { Redirect } from 'react-router-dom';

import { SCREEN_ID_USER_TOKEN_LOGIN } from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import SrBox from 'client/components/SrBox';
import SrErrorMessage from 'client/components/SrErrorMessage/SrErrorMessage';

import AuthActions from 'client/actions/Auth';

@withTransitionHook
@withScreenId(SCREEN_ID_USER_TOKEN_LOGIN)
@withScrollToTop
@branch()
class UserTokenLoginPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Login | Sunroom Rentals',
  });

  constructor(props) {
    super(props);
    this.state = {
      redirectTo: null,
    };
  }

  componentDidMount() {
    const { location, dispatch } = this.props;
    const locationQuery = queryString.parse(location.search);

    if (locationQuery.token) {
      dispatch(AuthActions.login, {
        autoLoginToken: locationQuery.token,
      }).then(() => {
        this.setState({
          redirectTo: locationQuery.pathRedirect || '/partner',
        });
      });
    }
  }

  render() {
    const { location } = this.props;
    const locationQuery = queryString.parse(location.search);

    const { redirectTo } = this.state;
    return (
      <SrBox width="100%" height="100%" textAlign="center">
        {locationQuery.token && (
          <>
            <div className="loading-gif" />
            {redirectTo && <Redirect to={redirectTo} />}
          </>
        )}
        {!locationQuery.token && (
          <SrErrorMessage>Warning: No `token` found in query string parameters.</SrErrorMessage>
        )}
      </SrBox>
    );
  }
}

UserTokenLoginPage.displayName = 'UserTokenLoginPage';

export default UserTokenLoginPage;
